import { Link } from 'react-router-dom'
import s from './styles.module.scss'
import images from 'images'

export default function Main({ fullscreen, setFullscreen }) {
  return (
    <>
      <div id='nav' className={s.outernav}>
        <nav className={s.nav}>
          <div className={s.left}>
            <Link to='/home'>
              <img src={images.logoWhite} alt='' />
            </Link>
          </div>

          <div className={s.right}>
            <NavLinks />
          </div>
        </nav>
      </div>

      {!!fullscreen && (
        <div className={s.fullscreenMenu} onClick={() => setFullscreen(false)}>
          <div className={s.close + ' material-icons'}>close</div>
          <NavLinks />
        </div>
      )}

      <div className={s.hamburger + ' material-icons'} onClick={() => setFullscreen(true)}>
        menu
      </div>
    </>
  )
}

const NavLinks = () => {
  const adminData = JSON.parse(window.localStorage.getItem('adminData'))
  var navLinks = []

  if (adminData && adminData.access === 'superAdmin') navLinks = superAdminNavLinks
  else navLinks = adminNavLinks

  const isImpersonating = window.localStorage.getItem('impersonating') === 'true'

  const exitImpersonation = () => {
    const adminAuth = window.localStorage.getItem('adminAuthorization')
    const adminUserData = window.localStorage.getItem('adminUserData')
    if (adminAuth && adminUserData) {
      window.localStorage.setItem('authorization', adminAuth)
      window.localStorage.setItem('userData', adminUserData)
    }
    window.localStorage.removeItem('adminAuthorization')
    window.localStorage.removeItem('adminUserData')
    window.localStorage.removeItem('impersonating')
    window.location.assign('/admin/users')
  }

  return (
    <div className={s.navLinks}>
      {isImpersonating && (
        <div onClick={exitImpersonation} className={s.exitImpersonation} title='Return to Admin'>
          <span className='material-icons-outlined'>switch_account</span>
          <div className={s.fieldName}>Exit Impersonation</div>
        </div>
      )}
      {navLinks.map(({ name, path, icon }, i) => (
        <Link key={i} to={path} className={window.location.pathname.startsWith(path) ? s.active : ''} title={name}>
          <span className='material-icons-outlined'>{icon}</span>
          <div className={s.fieldName}>{name}</div>
        </Link>
      ))}
    </div>
  )
}

const adminNavLinks = [
  {
    name: 'CRM Dashboard',
    path: '/admin/crm',
    icon: 'dashboard'
  },
  {
    name: 'Dashboard',
    path: '/admin/dashboard/features',
    icon: 'insights'
  },
  // {
  //   name: 'Overview',
  //   path: '/admin/dashboard/overview',
  //   icon: 'insights'
  // },
  {
    name: 'Activity',
    path: '/admin/analytics/activity',
    icon: 'insights'
  },
  {
    name: 'Referrals',
    path: '/admin/analytics/referrals',
    icon: 'group_add'
  },
  {
    name: 'Users',
    path: '/admin/users',
    icon: 'people'
  },
  {
    name: 'Businesses',
    path: '/admin/businesses',
    icon: 'business'
  },
  {
    name: 'Aadhaar Verification',
    path: '/admin/aadhaarVerification',
    icon: 'verified_user'
  },
  {
    name: 'Call Management',
    path: '/admin/crm/calls',
    icon: 'phone'
  },
  {
    name: 'Approval Requests',
    path: '/admin/approvalRequests',
    icon: 'event_available'
  },
  {
    name: 'Push Notifications',
    path: '/admin/pushNotifications',
    icon: 'notifications_active'
  },
  {
    name: 'News Feed Settings',
    path: '/admin/newsFeedSettings',
    icon: 'rss_feed'
  },
  {
    name: 'Social Media Settings',
    path: '/admin/socialMediaSettings',
    icon: 'share'
  },
  {
    name: 'Pending News',
    path: '/admin/pendingNews',
    icon: 'article'
  },
  {
    name: 'Spirituality',
    path: '/admin/spirituality',
    icon: 'self_improvement' 
  },
  {
    name: 'Events',
    path: '/admin/events',
    icon: 'event'
  },
  {
    name: 'Matrimonial Create',
    path: '/admin/matrimonial/create',
    icon: 'person_add'
  },
  {
    name: 'Create Job',
    path: '/admin/jobs/create',
    icon: 'work'
  },
  {
    name: 'Create Candidate',
    path: '/admin/resume/create',
    icon: 'badge'
  },
  // {
  //   name: 'Pending References',
  //   path: '/admin/matrimonial/pendingReferences',
  //   icon: 'fact_check'
  // },
   {
    name: 'Social Feed',
    path: '/admin/socialFeed',
    icon: 'rss_feed' 
  },
  {
    name: 'Edit Profile',
    path: '/admin/editProfile',
    icon: 'edit'
  },
  {
    name: 'Membership Fees',
    path: '/admin/settings/membership-fees',
    icon: 'price_change'
  },
  {
    name: 'Sign Out',
    path: '/signOut',
    icon: 'logout'
  }
]

const superAdminNavLinks = [
  {
    name: 'CRM Dashboard',
    path: '/admin/crm',
    icon: 'dashboard'
  },
  {
    name: 'Dashboard',
    path: '/admin/dashboard/features',
    icon: 'insights'
  },
  // {
  //   name: 'Overview',
  //   path: '/admin/dashboard/overview',
  //   icon: 'insights'
  // },
  {
    name: 'Activity',
    path: '/admin/analytics/activity',
    icon: 'insights'
  },
  {
    name: 'Referrals',
    path: '/admin/analytics/referrals',
    icon: 'group_add'
  },
  {
    name: 'Users',
    path: '/admin/users',
    icon: 'people'
  },
  {
    name: 'Businesses',
    path: '/admin/businesses',
    icon: 'business'
  },
  {
    name: 'Aadhaar Verification',
    path: '/admin/aadhaarVerification',
    icon: 'verified_user'
  },
  {
    name: 'Call Management',
    path: '/admin/crm/calls',
    icon: 'phone'
  },
  {
    name: 'Approval Requests',
    path: '/admin/approvalRequests',
    icon: 'event_available'
  },
  {
    name: 'Push Notifications',
    path: '/admin/pushNotifications',
    icon: 'notifications_active'
  },
  {
    name: 'News Feed Settings',
    path: '/admin/newsFeedSettings',
    icon: 'rss_feed'
  },
  {
    name: 'Social Media Settings',
    path: '/admin/socialMediaSettings',
    icon: 'share'
  },
  {
    name: 'Pending News',
    path: '/admin/pendingNews',
    icon: 'article'
  },
  {
    name: 'Admins',
    path: '/admin/admins',
    icon: 'admin_panel_settings'
  },
  {
    name: 'Matrimonial Create',
    path: '/admin/matrimonial/create',
    icon: 'person_add'
  },
  {
    name: 'Create Job',
    path: '/admin/jobs/create',
    icon: 'work'
  },
  {
    name: 'Create Candidate',
    path: '/admin/resume/create',
    icon: 'badge'
  },
  // {
  //   name: 'Pending References',
  //   path: '/admin/matrimonial/pendingReferences',
  //   icon: 'fact_check'
  // },
  {
    name: 'Spirituality',
    path: '/admin/spirituality',
    icon: 'self_improvement'
  },
  {
    name: 'Events',
    path: '/admin/events',
    icon: 'event'
  },
  {
    name: 'Social Feed',
    path: '/admin/socialFeed',
    icon: 'rss_feed'
  },
  {
    name: 'Edit Profile',
    path: '/admin/editProfile',
    icon: 'edit'
  },
  {
    name: 'Membership Fees',
    path: '/admin/settings/membership-fees',
    icon: 'price_change'
  },
  {
    name: 'Sign Out',
    path: '/signOut',
    icon: 'logout'
  }
]
